import React, { useState } from 'react';
import { Modal, Button, Form, Input } from 'antd';

const ModalForm = ({ visible, onCreate, onCancel, params = [], onPost, isLoading = false }) => {
    const [form] = Form.useForm();

    return (
        <Modal
            loading={isLoading}
            open={visible}
            title="Journey Details"
            cancelText="Close"
            onCancel={onCancel}
            okButtonProps={{ style: { display: 'none' } }}
        >
            {params.length > 0 && params.map((_row, i) =>
            (
                <>
                    <div className='card border-start-lg border-start-primary h-100 mb-4'>
                        <div class="card-header"><h3 className='text-primary'>{_row['nomor']}</h3></div>
                        <div className='card-body'>

                            {_row['data'].map((_detail, j) => {
                                return _detail['data'].map((_rw, jj) => {
                                    return (
                                        <div class="card card-header-actions">
                                            <div class="card-header">
                                                <span style={{ fontSize: 17, fontWeight: 600 }}>{_detail['type']}</span>
                                                {
                                                    _rw.DocNum === "" && (
                                                        <button
                                                            onClick={(e) => onPost(e, _detail['type'], _row['nomor'], _detail['data'][0].payload)}
                                                            className="btn btn-success btn-sm"
                                                            type="button"
                                                        >POST SAP <span className="fas fa-play ml-2"></span>
                                                        </button>
                                                    )}

                                            </div>
                                            <div class="card-body">
                                                <ul>
                                                    <li>Docnum : {_rw.DocNum !== "" ? _rw.DocNum : '-'}</li>
                                                    <li>Status : {_rw.Status}</li>
                                                    <li>Canceled : {_rw.Cancelled}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    )
                                })
                            })}

                        </div>
                    </div>
                </>
            )
            )}
        </Modal>

    );

}
export default ModalForm;